var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center",staticStyle:{"margin-bottom":"-20px"}},[_c('h2',[_vm._v(_vm._s(_vm.$t( 'home.vacancyCount' ))+":\n\n    "),_c('b-badge',{attrs:{"variant":"primary"}},[_vm._v(_vm._s(_vm.total))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }